import axios from "axios";
import instanceTokenLess from "../../../../axiosTokenLess";
import instance from "../../../../axios";
export const BASE_URL = `${process.env.REACT_APP_API_URL}`
export const API_URL = `${process.env.REACT_APP_API_URL}/apk-screens`;

 export function getAPKScreenList(queryParams) {
  return instanceTokenLess.post(`${API_URL}/list`, queryParams)
  .then(res => {
      return res;
  })
};


export function createItem(item) {
  return instanceTokenLess.post(`${API_URL}/create`, item)
  .then(res => {
      return res;
  })
};

// READ
export function getList(queryParams) {
  return instanceTokenLess.post(`${API_URL}/list`, queryParams)
  .then(res => {
      return res;
  })
};
export function getItemById(id) {
  const selectedCompany = localStorage.getItem('selectedCompanyy');
  if (!selectedCompany) {
    return Promise.reject(new Error("No company selected"));
  }
  const payload = {
    id: id,
    company: selectedCompany, 
  };
  return instanceTokenLess.post(`${API_URL}/get/${id}`, payload)
  .then(res => {
      return res;
  })
};
export function getCompany(queryParams) {
  return instance
    .post(`${BASE_URL}/v3/dropdown/company/short`, queryParams)
    .then((res) => {
      return res;
    });
}
export function fetchCompanyDropdownList(queryParams) {
  return instance
    .post(`${process.env.REACT_APP_API_URL}/v3/dropdown/company/short`, queryParams)
    .then((res) => {
      return res;
    });
}
export function findItem(queryParams) {
  return instanceTokenLess.post(`${API_URL}/find`, { queryParams })
  .then(res => {
    return res;
})
}


export function updateItem(item) {
  // Retrieve the selected company from local storage
  const selectedCompany = localStorage.getItem('selectedCompanyy');

  // Check if a company was selected in local storage
  if (!selectedCompany) {
    // Handle the case where no company is selected in local storage
    return Promise.reject(new Error("No company selected"));
  }

  // Add the "company" property to the item object
  item.company = selectedCompany.trim().toLowerCase();
 return instanceTokenLess.post(`${API_URL}/update/${item._id}`, item)
  .then(res => {
     return res;
 })
}

// UPDATE Status
export function updateItemsStatus(ids, status) {
  return instanceTokenLess.post(`${API_URL}/updateStatusForitems`, {
    ids,
    status
  });
}

export function deleteItem(id) {
  // Retrieve the selected company from local storage
  const selectedCompany = localStorage.getItem('selectedCompanyy');

  // Check if a company was selected in local storage
  if (!selectedCompany) {
    // Handle the case where no company is selected in local storage
    return Promise.reject(new Error("No company selected"));
  }

  const payload = {
    company: selectedCompany.trim().toLowerCase()
  };
return instanceTokenLess.post(`${API_URL}/delete/${id}`, payload)
 .then(res => {
    return res;
})
}

// DELETE items by ids
export function deleteItems(ids) {
 // Retrieve the selected company from local storage
 const selectedCompany = localStorage.getItem('selectedCompanyy');

 // Check if a company was selected in local storage
 if (!selectedCompany) {
   // Handle the case where no company is selected in local storage
   return Promise.reject(new Error("No company selected"));
 }

 const payload = {
   company: selectedCompany.trim().toLowerCase(),
   ids: ids
 };
return instanceTokenLess.post(`${API_URL}/deleteitems`, payload)
 .then(res => {
    return res;
})
}
